/* Cart drawer + /cart page enhancements (FIX F, 28 Sep 2026). Loaded once per page as a module from snippets/side-cart.liquid.
   The drawer itself (open/close, focus trap, Escape, ajax add/change) stays in the legacy assets/theme.js.liquid; this file adds:
   - dialog semantics on #CartDrawer (role=dialog, aria-modal, labelled by the "Your cart" heading)
   - focus returns to the control that opened the drawer (ATC, sticky ATC, header cart) on Escape / close / overlay tap
   - a polite live region: "Added to cart: …", quantity changes, the Pair upgrade
   - focus kept on the −/+ button after the drawer re-renders
   - "Make it a Pair" swap (drawer + /cart page): one POST /cart/update.js, then the drawer is re-rendered
   - gift note saved on change; express checkout buttons re-initialised after each re-render
   - assets/rr-cart.css injected once (the /cart page links it itself) */
(function () {
  "use strict";
  if (window.__rrCart) return;
  window.__rrCart = true;

  var drawer = document.getElementById("CartDrawer");
  var box = document.getElementById("CartContainer");

  /* ---- styles ---- */
  var cssHost = document.querySelector("[data-rr-cart-css]");
  if (cssHost && !document.querySelector('link[href*="rr-cart.css"]')) {
    var l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = cssHost.getAttribute("data-rr-cart-css");
    document.head.appendChild(l);
  }

  /* ---- live region ---- */
  var live = document.createElement("div");
  live.className = "rr-vh";
  live.setAttribute("aria-live", "polite");
  live.setAttribute("role", "status");
  document.body.appendChild(live);
  var liveT = null;
  function say(msg) {
    live.textContent = "";
    clearTimeout(liveT);
    liveT = setTimeout(function () { live.textContent = msg; }, 60);
  }

  function cleanTitle(t) { return String(t || "").split(" (")[0].split("|")[0].replace(/\s+x\s+[23]$/, "").trim(); }

  /* ---- dialog semantics ---- */
  if (drawer) {
    drawer.setAttribute("role", "dialog");
    drawer.setAttribute("aria-modal", "true");
    drawer.setAttribute("aria-labelledby", "rr-cart-title");
  }

  /* ---- opener tracking + focus return ---- */
  var lastOutside = null, opener = null;
  function remember(e) {
    if (!drawer || drawer.contains(e.target)) return;
    var el = e.target.closest ? e.target.closest("a[href],button,input,select,textarea,[tabindex]") : null;
    if (el) lastOutside = el;
  }
  document.addEventListener("pointerdown", remember, true);
  document.addEventListener("focusin", remember, true);
  document.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") remember(e); }, true);

  function visible(el) {
    if (!el || !el.isConnected) return false;
    if (el.closest("[inert]")) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  var isOpen = document.body.classList.contains("js-drawer-open-right");
  new MutationObserver(function () {
    var now = document.body.classList.contains("js-drawer-open-right");
    if (now === isOpen) return;
    isOpen = now;
    if (now) {
      opener = lastOutside;
    } else {
      var a = document.activeElement;
      if (!a || a === document.body || (drawer && drawer.contains(a))) {
        var target = opener;
        /* the sticky ATC hides itself when the main button is in view: fall back to the header cart link */
        if (!visible(target)) target = document.querySelector("[data-rr-cart-link]") || document.querySelector(".js-drawer-open-right");
        if (target && visible(target)) { try { target.focus({ preventScroll: true }); } catch (x) { target.focus(); } }
      }
      opener = null;
    }
  }).observe(document.body, { attributes: true, attributeFilter: ["class"] });

  /* ---- "Added to cart" (every jQuery add: PDP, homepage, collection, legacy product forms) ---- */
  function hookJq() {
    var $ = window.jQuery;
    if (!$ || hookJq.done) return;
    hookJq.done = true;
    $(document).on("ajaxSuccess", function (ev, xhr, opts) {
      if (!opts || !/\/cart\/add(\.js)?/.test(opts.url || "")) return;
      var j = xhr && xhr.responseJSON;
      var name = j && (j.product_title || j.title);
      say("Added to cart" + (name ? ": " + cleanTitle(name) : "") + ".");
    });
  }
  hookJq();
  document.addEventListener("DOMContentLoaded", hookJq);

  /* ---- drawer re-render bookkeeping ---- */
  var pendingQty = null;   /* {variant, dir} of the −/+ button that was tapped */
  var pendingFocus = null; /* "title" after a swap / remove */
  document.addEventListener("click", function (e) {
    var q = e.target.closest && e.target.closest("#CartDrawer .qty-step-btn");
    if (q) {
      var row = q.closest(".line-item");
      pendingQty = { variant: row && row.getAttribute("data-variant-id"), dir: q.getAttribute("data-qty-change") };
    }
    if (e.target.closest && e.target.closest("#CartDrawer .line-item--remove-btn")) { pendingFocus = "title"; say("Item removed."); }
  }, true);

  function afterRender() {
    if (window.Shopify && Shopify.StorefrontExpressButtons && typeof Shopify.StorefrontExpressButtons.initialize === "function") {
      try { Shopify.StorefrontExpressButtons.initialize(); } catch (x) {}
    }
    if (box && box.querySelector("[data-rr-x-missing]") && !document.getElementById("cart-page--inner")) { refreshDrawer(); return; }
    if (!isOpen || !drawer) return;
    if (pendingQty) {
      var row = drawer.querySelector('.line-item[data-variant-id="' + pendingQty.variant + '"]');
      var btn = row && row.querySelector('.qty-step-btn[data-qty-change="' + pendingQty.dir + '"]');
      var n = row && row.querySelector(".qty-step-count");
      if (btn) btn.focus();
      else { var t0 = document.getElementById("rr-cart-title"); if (t0) t0.focus(); }
      say(n ? "Quantity " + n.textContent.trim() + "." : "Item removed.");
      pendingQty = null;
    } else if (pendingFocus === "title") {
      var t = document.getElementById("rr-cart-title");
      if (t) t.focus();
      pendingFocus = null;
    }
  }
  if (box && "MutationObserver" in window) {
    var mt = null;
    new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(afterRender, 30); }).observe(box, { childList: true, subtree: true });
  }

  /* ---- re-render the drawer from the inline cart template ---- */
  function refreshDrawer() {
    return fetch("/cart?view=inline-cart-contents", { credentials: "same-origin", headers: { Accept: "text/html" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString("<div>" + html + "</div>", "text/html");
        var fresh = doc.querySelector(".inline-cart--container");
        var cur = document.querySelector("#CartContainer .inline-cart--container");
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      });
  }

  /* ---- Make it a Pair ---- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-rr-upsell-swap]");
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    var row = b.closest("[data-rr-upsell]");
    var err = row && row.querySelector(".rr-up__err");
    var lab = b.querySelector("[data-rr-upsell-label]");
    var idle = lab ? lab.textContent : "";
    b.disabled = true;
    if (lab) lab.textContent = "Updating…";
    if (err) err.setAttribute("hidden", "");
    var updates = {};
    updates[b.getAttribute("data-from")] = 0;
    updates[b.getAttribute("data-to")] = 1;
    var inPage = !!b.closest("#cart-page--inner");
    fetch("/cart/update.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || "");
        if (inPage) { window.location.reload(); return; }
        pendingFocus = "title";
        return refreshDrawer().then(function () {
          say("Upgraded to The Pair: 2 rockers in " + (b.getAttribute("data-colour") || "your colour") + ".");
        });
      })
      .catch(function (x) {
        b.disabled = false;
        if (lab) lab.textContent = idle;
        if (err) { err.textContent = (x && x.message) || "Sorry, that didn't work. Please try again."; err.removeAttribute("hidden"); }
      });
  });

  /* ---- gift note: save as soon as it changes (the checkout button also posts it) ---- */
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (!t || t.name !== "note" || !t.closest || !t.closest("#CartDrawer")) return;
    fetch("/cart/update.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ note: t.value })
    }).catch(function () {});
  });
})();
